import type { MaturityAreaKey, MaturityItemId } from '@cobliteam/hooks/src/useBasicValueMaturity/basicValueMaturityModel';
import { BellRing, Boxes, Cable, Car, ClipboardCheck, Gauge, Link2, type LucideIcon, MapPin, Router, Truck, UserPlus, Users, Wrench } from 'lucide-react';

/**
 * Presentation-only mapping (icons) for the maturity model. Kept in the app layer so the shared
 * `@cobliteam/hooks` model stays free of JSX / lucide. Copy lives in i18n, keyed by the same ids.
 */
export const AREA_ICON: Record<MaturityAreaKey, LucideIcon> = {
  installation: Wrench,
  setup: Users,
  configuration: Car,
};

export const ITEM_ICON: Record<MaturityItemId, LucideIcon> = {
  devices: Router,
  vehicles: Truck,
  'device-association': Cable,
  drivers: Users,
  'driver-association': Link2,
  users: UserPlus,
  groups: Boxes,
  alerts: BellRing,
  speed: Gauge,
  geofences: MapPin,
  checklists: ClipboardCheck,
};
